import { Panel } from './panel';

export class CharacterPortrait extends Panel {
    render({ view }) {
        // view.backgroundColor('white');
    }
}